export default function getColSizeByCampaignContent(layout?: string): {
  md?: number;
  sm?: number;
  lg?: number;
} {
  switch (layout) {
    case 'Vertical Tile':
      return { md: 3, sm: 12 };
    case 'Statistic Tile':
    case 'Gallery Tile':
      return { lg: 3, md: 6, sm: 12 };
    case 'Full Width':
    case 'Horizontal Left Image':
    case 'Horizontal Right Image':
      return { md: 12, sm: 12 };
    default:
      return { md: 12, sm: 12 };
  }
}
